import { memo } from 'react'
import LottiePlayer from '../LottiePlayer'

/** Premium plan hero from Figma component `premium block` (64:23233). */
const GRADIENTS = {
  '3': 'radial-gradient(50% 50% at 50% 50%, rgba(156,222,29,1) 0%, rgba(122,202,15,1) 52%, rgba(87,182,1,1) 100%)',
  '6': 'radial-gradient(50% 50% at 50% 50%, rgba(110,210,255,1) 0%, rgba(77,181,255,1) 52%, rgba(44,152,255,1) 100%)',
  '12': 'radial-gradient(50% 50% at 50% 50%, rgba(255,91,84,1) 0%, rgba(244,57,66,1) 100%)',
}

const DURATION_TEXT = { '3': '3 месяца', '6': '6 месяцев', '12': '12 месяцев' }
const PREMIUM_ANIMATIONS = {
  '3': '/images/lottie/json/premium_3.json',
  '6': '/images/lottie/json/premium_6.json',
  '12': '/images/lottie/json/premium_12.json',
}
const STAR_ASSETS = {
  9: '/images/premium/premium-star-9.svg',
  12: '/images/premium/premium-star-12.svg',
  24: '/images/premium/premium-star-24.svg',
  36: '/images/premium/premium-star-36.svg',
}

// Positions and leaf sizes are the exported Figma `stars decoration` values.
const STAR_DECORATIONS = [
  [24, 240, 97], [24, 107, 40], [24, 319, 96], [24, 26, 257], [24, 44, 170],
  [9, 264, 181], [9, 273, 257], [9, 90, 358], [9, 90, 242], [9, 326, 350],
  [9, 151, 20], [9, 56, 17], [9, 28, 132], [9, 29, 350],
  [12, 95, 120], [12, 320, 280], [12, 190, 51], [12, 326, 28],
  [36, 308, 182], [36, 26, 47], [36, 264, 22],
]

const BANNER_HEIGHT = 320

function PremiumBlock({ type = '6', subtitle = 'Telegram Premium', subtitleLoading = false, className = '' }) {
  const planType = String(type)

  return (
    <div
      className={`relative flex h-[320px] w-full max-w-[361px] flex-col items-center justify-center gap-2 overflow-hidden rounded-[16px] p-6 ${className}`}
      style={{ background: GRADIENTS[planType] || GRADIENTS['6'] }}
    >
      <div className="relative z-[1] h-[164px] w-[164px] shrink-0" aria-hidden="true">
        <LottiePlayer
          animationUrl={PREMIUM_ANIMATIONS[planType] || PREMIUM_ANIMATIONS['6']}
          className="h-full w-full"
        />
      </div>
      <div className="relative z-[1] flex shrink-0 flex-col items-center justify-center gap-1 text-center text-white">
        <p className="whitespace-nowrap text-[48px] font-[590] leading-[58px] tracking-[-1px]">{DURATION_TEXT[planType] || DURATION_TEXT['6']}</p>
        {subtitleLoading ? (
          <span
            className="inline-block h-5 w-[76px] animate-pulse rounded-full bg-white/35"
            aria-label="Загрузка цены"
          />
        ) : (
          <p className="min-w-[76px] whitespace-nowrap text-[16px] font-[510] leading-5 tracking-[-1px] text-white/90">{subtitle}</p>
        )}
      </div>
      <div className="pointer-events-none absolute inset-0 z-[2] overflow-hidden rounded-[16px]" aria-hidden="true">
        {STAR_DECORATIONS.map(([size, left, top], index) => (
          <img
            key={`${size}-${left}-${top}-${index}`}
            src={STAR_ASSETS[size]}
            alt=""
            loading="eager"
            className="absolute block max-w-none mix-blend-soft-light"
            style={{ width: size, height: size, left, top: Math.min(top, BANNER_HEIGHT - size - 2) }}
          />
        ))}
      </div>
    </div>
  )
}

export default memo(PremiumBlock)
